import { EventbookingCommentActionTypes } from './constants';

export const listEventbookingComments = (actionType: string, data: any): EventbookingCommentAction => ({
    type: EventbookingCommentActionTypes.LIST_EVENTBOOKING_COMMENT,
    payload: { data },
});

export const updateEventbookingCommentStatus = (eventbooking_id) => ({
    type: EventbookingCommentActionTypes.UPDATE_EVENTBOOKING_COMMENT,
    payload: { eventbooking_id },
});

export const createEventbookingCommentMessage = (data, id): EventbookingCommentAction => ({
    type: EventbookingCommentActionTypes.CREATE_EVENTBOOKING_COMMENT,
    payload: { data, id},
});

export const updateEventbookingCommentMessage = (data, id): EventbookingCommentAction => ({
    type: EventbookingCommentActionTypes.UPDATE_MESSAGE_EVENTBOOKING_COMMENT,
    payload: { data, id},
});


export const deleteEventbookingCommentMessage = (id): EventbookingCommentAction => ({
    type: EventbookingCommentActionTypes.DELETE_EVENTBOOKING_COMMENT,
    payload: { id},
});

export const authApiResponseSuccess = (actionType: string, data: any): EventbookingCommentAction => ({
    type: EventbookingCommentActionTypes.API_RESPONSE_SUCCESS,
    payload: { actionType, data },
});


export const authApiResponseError = (actionType: string, error: string): EventbookingCommentAction => ({
    type: EventbookingCommentActionTypes.API_RESPONSE_ERROR,
    payload: { actionType, error },
});
